<template>
  <v-card class="absolutePosition" style="top:20%; left: calc(50% - 200px); display:none;" width="400px">
    <v-container ref="container" class="widgetText--text widget pa-0" style="position: relative; height: 100%; overflow: hidden">
      <BaseWidgetHeader ref="widgetHeader" :label="title" @close-parent-widget="close" />
      <v-row
        class="px-5 py-2" style="max-height:300px;overflow-y: scroll;">
        <v-col
          v-for="(dashboard, index) in dashboards"
          :key="index"
          class="hover text-center"
          cols="12" align-content="center" align-self="center"
          @click="open(dashboard.id)">
          <v-hover v-slot="{hover}" close-delay="200">
            <v-card
              class="pa-2" outlined tile
              :elevation="hover ? 2 : 0"
              :class="{'on-hover': hover}">
              <v-icon
                size="85"
                class="pl-1">
                {{ dashboard.icon }}
              </v-icon>
              <br>
              <v-divider />
              <span class="dash-title">
                {{ dashboard.name }}
              </span>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>

export default {
  name: 'OdeonDashboards',
  data () {
    return {
      dashboards: [{
        id: 'https://gisportal.rs/portal/apps/sites/#/jppsreports',
        name: 'Dashboard',
        icon: ' mdi-chart-bell-curve',
      }],
    }
  },

  computed: {
    activeTool () {
      return this.$store.getters.getCenterActiveTool
    },
    title () {
      if (this.$store.getters.getLanguage === 'en') {
        return 'Dashboard'
      }
      return 'Dashboard'
    },
  },
  watch: {
    activeTool (newValue) {
      if (newValue === 'JppsDashboard') {
        this.open('https://gisportal.rs/portal/apps/sites/#/jppsreports')
      }
    },
  },
  mounted () {
    this.open('https://gisportal.rs/portal/apps/sites/#/jppsreports')
  },
  methods: {
    close () {
      this.$store.dispatch('unStoreCenterActiveTool')
    },
    open (url) {
      window.open(url, '_blank')
      this.$store.dispatch('unStoreCenterActiveTool')
    },

  },
}
</script>
<style scoped>

.hover:hover {
  cursor: pointer;
}
</style>
<style scoped>
.absolutePosition {
    position: absolute;
    display: block;
    z-index: 100;
}
.dash-title {
  font-size: 14px;;
}
</style>
